import type { EngageTenantUsage } from '@reach/shared-types/engage-tenants';
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './EngageTenantRow.module.css';

interface EngageTenantRowProps {
  rank: number;
  tenant: EngageTenantUsage;
}

export const EngageTenantRow: React.FC<EngageTenantRowProps> = ({ rank, tenant }) => {
  return (
    <tr className={styles.row}>
      <td className={styles.rank}>{rank}</td>
      <td className={styles.tenantCell}>
        <Link className={styles.tenantLink} to={`/dashboard/tenants/${tenant.tenantId}`}>
          {tenant.tenantName}
        </Link>
      </td>
      <td className={styles.sends}>{tenant.emailsSent.toLocaleString()}</td>
      <td className={styles.sends}>{tenant.smsSent.toLocaleString()}</td>
      <td className={styles.currentState}>{tenant.activeAutomations.toLocaleString()}</td>
      <td className={styles.currentState}>{tenant.smsNumberCount.toLocaleString()}</td>
    </tr>
  );
};
